import {API_HOST, catchError, AXIOS_INSTANCE} from './api'
import axios from 'axios'

const FORMS = "form";
const FORMS_STEPS = "form-steps";

export async function GET_FORM(type) {
  try {
    const response = await AXIOS_INSTANCE.get(`${API_HOST}/${FORMS}/${type}`, {
      headers: {
        'Authorization': 'Bearer ' + window.localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (e) {
    catchError(e);
  }
}
export async function POST_FORM(kit, data) {
  let answers = {
    answers: data
  };
  console.log('?');
  try {
    const response = await AXIOS_INSTANCE.post(`${API_HOST}/${FORMS_STEPS}/${kit}`, answers, {
      headers: {
        'Authorization': 'Bearer ' + window.localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (e) {
    catchError(e);
  }
}


// WEBPACK FOOTER //
// ./src/services/form.js